exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tbody td[data-v-aba94e00] {\n  vertical-align: middle;\n}\n.kiosk-company-logo[data-v-aba94e00] {\n  padding: 0 !important;\n  text-align: center;\n  width: 60px;\n}\n", ""]);

// exports
